<template lang="pug">
  v-flex.profile-page.inicio-panel.mt-2.border-radius-top(xs12 sm12 md8 lg8)
    v-container
      v-layout(row wrap)
        v-flex(xs1 sm1 md2 lg2)
        v-flex(xs10 sm10 md8 lg8)
          v-btn.back-to-main(@click="$router.push('/inicio')" v-if="$vuetify.breakpoint.mdAndUp")
            img(:src="arrowBack" alt="arrowBack")
            | Atrás
          h2.omnesMedium.datos-personales
            | {{ title }}
          h3.omnesMedium.datos-personales Datos personales
          p.datos-personales
            span.omnesMedium Nombre
            span.omnesRegular(v-if="basicInfo") {{ basicInfo.nombres + ' ' + basicInfo.apellidoPaterno + ' ' + basicInfo.apellidoMaterno }}
          p.datos-personales
            span.omnesMedium N° de doc.
            span.omnesRegular(v-if="basicInfo") {{ basicInfo.numeroDocumento }}
        v-flex(xs1 sm1 md2 lg2)
    hr(v-if="$vuetify.breakpoint.smAndDown" style="color: #B2B4C7;")
    v-container
      form-profile(v-if="basicInfo" :profile="basicInfo")
</template>

<script>
import FormProfile from '@/components/FormProfile'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      title: 'Mis datos',
      arrowBack2: require('./../assets/icons/arrow-back.svg'),
      arrowBack: require('./../assets/cvc/left_arrow.svg')
    }
  },
  methods: {},
  mounted () {
    const self = this

    self.$root.$emit('npsInactivity', {seccion: 'Mi perfil'})
  },
  computed: {
    ...mapGetters('user', ['userInfo', 'basicInfo'])
  },
  components: {
    'form-profile': FormProfile
  }
}
</script>

<style>
  h2.datos-personales {
    color: #0855C4;
    margin: 0.5em 0;
  }
  h3.datos-personales {
    color: var(--text-color);
    margin-bottom: 0.7em;
  }
  p.datos-personales {
    color: var(--text-color);
    overflow: hidden;
  }
  p.datos-personales:first-of-type { margin-bottom: 6px; }
  p.datos-personales span { float: left; }
  p.datos-personales span:first-child { width: 150px; }
  p.datos-personales span:first-child + span { width: 275px; }
  .back-to-main {
    background-color: transparent !important;
    box-shadow: none !important;
    border: 1px solid #C9CAD4;
    border-radius: 22px;
    margin-right: 0;
    margin-left: 0;
  }
  .back-to-main .v-btn__content {
    text-transform: capitalize;
    font-size: 16px;
  }
  .back-to-main .v-btn__content img {
    width: 30%;
    margin-right: 5px;
  }
  .profile-page { background-color: #FFF }
  /* Mobile ----------- */
  @media only screen and (max-width : 600px) {
  }
  /* Desktop ----------- */
  @media screen and (min-width:992px) {
    .profile-page {
      height: max-content;
    }
  }
  @media only screen  and (min-width : 1265px) {
    .profile-page .container:first-of-type + .container {
      border-top: 0;
    }
    .profile-page .container:first-of-type { padding-left: 10%; }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Profile.vue